import React from "react";

import useAdminItem from "../hooks/useAdminItem";
import AdminItem from "../components/AdminItem";

export default function AdminItemInterface(props) {
  const {
    payProviderMetadata,
    title,
    description,
    location,
    tags,
    tagsAsMenu,
    prices,
    nb,
    available,
    busy,
    files,
    filesUploaded,
    dimensions,
    platforms,
    submitting,
    currentItem,
    published,
    isRecurrent,
    hasMultiplePrices,
    isFreeTicket,
    dialogPricing,
    superUser,
    eventPlanner,
    isEvent,
    requiredFormular,
    dataMenus,
    handlePostItem,
    onTitleChange,
    onDescriptionChange,
    onLocationChange,
    onTagsChange,
    onTagsAsMenuChange,
    onNbItemChange,
    onFileChange,
    onChangeDimension,
    onDeleteDimension,
    onAddDimension,
    onUpdateDimension,
    onStatusPublishedChange,
    onSubscriptionChange,
    onMultiplePricesChange,
    onFreeTicketChange,
    openDialogPricing,
    onDialogClosePricing,
    onSavePrice,
    onDeleteSavedPrice,
    onEventPlanner,
    onSetEvent,
    onSetFormular,
    onSaveMenuForItemRefresh,
    onHandleDeleteFile,
  } = useAdminItem(props);

  const { onCancelAction } = props;

  return (
    <AdminItem
      superUser={superUser}
      payProviderMetadata={payProviderMetadata}
      title={title}
      description={description}
      location={location}
      tags={tags}
      tagsAsMenu={tagsAsMenu}
      prices={prices}
      nb={nb}
      available={available}
      busy={busy}
      files={files}
      filesUploaded={filesUploaded}
      dimensions={dimensions}
      platforms={platforms}
      published={published}
      isRecurrent={isRecurrent}
      hasMultiplePrices={hasMultiplePrices}
      isFreeTicket={isFreeTicket}
      eventPlanner={eventPlanner}
      isEvent={isEvent}
      requiredFormular={requiredFormular}
      dataMenus={dataMenus}
      handlePostItem={handlePostItem}
      onTitleChange={onTitleChange}
      onDescriptionChange={onDescriptionChange}
      onLocationChange={onLocationChange}
      onTagsChange={onTagsChange}
      onTagsAsMenuChange={onTagsAsMenuChange}
      onNbItemChange={onNbItemChange}
      onFileChange={onFileChange}
      submitting={submitting}
      currentItem={currentItem}
      dialogPricing={dialogPricing}
      onCancelAction={onCancelAction}
      onChangeDimension={onChangeDimension}
      onDeleteDimension={onDeleteDimension}
      onAddDimension={onAddDimension}
      onUpdateDimension={onUpdateDimension}
      onStatusPublishedChange={onStatusPublishedChange}
      onSubscriptionChange={onSubscriptionChange}
      onMultiplePricesChange={onMultiplePricesChange}
      onFreeTicketChange={onFreeTicketChange}
      openDialogPricing={openDialogPricing}
      onDialogClosePricing={onDialogClosePricing}
      onSavePrice={onSavePrice}
      onDeleteSavedPrice={onDeleteSavedPrice}
      onEventPlanner={onEventPlanner}
      onSetEvent={onSetEvent}
      onSetFormular={onSetFormular}
      onSaveMenuForItemRefresh={onSaveMenuForItemRefresh}
      onHandleDeleteFile={onHandleDeleteFile}
    />
  );
}
